import React from "react"
import {
  careHomeCostPath,
  englandAssetsValue,
  scotlandAssetsValue,
} from "../../../../AverageCareHomeCosts/AverageCareHomeCosts"
import { formatNumberAsGbp } from "../../../../AverageCareHomeCosts/PricePerWeek/PricePerWeek"
import { InlineText } from "../../../../../Typography/Typography"
import SmartLink from "../../../../../layout/SmartLink/SmartLink"

const fundingArticleLinkClickEvent = (url) => ({
  name: "SEO - Filtered Directory - FAQs Care Home Funding Link Clicked",
  properties: { url },
})

const articleLink = (regulatoryBody) => {
  const country = regulatoryBody === "ci" ? "Scotland" : "England"

  return (
    <SmartLink
      to={careHomeCostPath[country]}
      clickEvent={fundingArticleLinkClickEvent(careHomeCostPath[country])}
    >
      <InlineText brand>
        Read our care home funding article for more advice.
      </InlineText>
    </SmartLink>
  )
}

// eslint-disable-next-line import/prefer-default-export
export const localFundingQA = (regulatoryBody, locationName) => {
  const localFundingAnswer =
    regulatoryBody === "ci"
      ? `In Scotland, if you are aged over 65 you are entitled to free personal and/or nursing care. If your total savings and property assets are below ${formatNumberAsGbp(
          scotlandAssetsValue,
        )} then you may also qualify for local council funding. `
      : `In England, if your total savings and property assets are below ${formatNumberAsGbp(
          englandAssetsValue,
        )}, then you may be able to access local authority funding towards accommodation costs, personal care and nursing care. `

  return {
    question: `Will I be entitled to local authority funding to help pay for a care home in ${locationName}?`,
    answer: (
      <>
        {localFundingAnswer}
        {articleLink(regulatoryBody)}
      </>
    ),
    structuredDataAnswer: localFundingAnswer,
  }
}
